export default __webpack_public_path__ + "static/media/Poppins-Medium.baa2a18a.woff2";